import type { DrawerFilter, FilterState } from '@backoffice-frontend/patterns'
import {
  MoiaDrawer,
  MoiaDrawerContent,
  MoiaDrawerFooter,
  MoiaDrawerHeader,
  MoiaFilterDrawerContent,
} from '@backoffice-frontend/patterns'
import { XIcon } from '@moia-dev/pace-icons'
import { Button } from '@moia-dev/pace-web'
import { useState } from 'react'
import { PatternCard } from '../../PatternLibraryArea/PatternDetails/PatternCard'
import { PatternStatus } from '../../status'

export const status = PatternStatus.UpToDate

export const description =
  'Filter Drawers are used to display and select filter options for data tables and lists.'

const mockFilters: DrawerFilter[] = [
  {
    id: 'status',
    label: 'Status',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'pending', label: 'Pending' },
    ],
    initiallyExpanded: true,
  },
  {
    id: 'role',
    label: 'Role',
    options: [
      { value: 'admin', label: 'Admin' },
      { value: 'user', label: 'User' },
      { value: 'guest', label: 'Guest' },
    ],
  },
  {
    id: 'location',
    label: 'Location',
    options: [
      { value: 'berlin', label: 'Berlin' },
      { value: 'hamburg', label: 'Hamburg' },
      { value: 'munich', label: 'Munich' },
    ],
  },
]

/**
 * A complete filter drawer component that combines MoiaDrawer with filter accordions
 */
export const FilterDrawer = ({
  onClose,
  title,
  filters,
  selectedFilters,
  setSelectedFilters,
  additionalContent,
  footer,
  className,
}: {
  /** Function to close the drawer */
  onClose: () => void
  /** Title of the drawer */
  title: React.ReactNode
  /** Array of filter configurations */
  filters: DrawerFilter[]
  /** Current filter state */
  selectedFilters: FilterState
  /** Function to update the filter state */
  setSelectedFilters: (filters: FilterState) => void
  /** Additional content to display at the bottom of the drawer */
  additionalContent?: React.ReactNode
  /** Custom footer content */
  footer?: React.ReactNode
  /** Optional CSS class name */
  className?: string
}) => {
  return (
    <MoiaDrawer className={className}>
      <MoiaDrawerHeader onClose={onClose}>{title}</MoiaDrawerHeader>
      <MoiaDrawerContent>
        <MoiaFilterDrawerContent
          filters={filters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        {additionalContent}
      </MoiaDrawerContent>
      {footer && <MoiaDrawerFooter>{footer}</MoiaDrawerFooter>}
    </MoiaDrawer>
  )
}

export const Pattern = () => {
  const [selectedFilters, setSelectedFilters] = useState<FilterState>({})

  return (
    <PatternCard title="Filter Drawer">
      <div>
        <p>{description}</p>
        <p>Status: {status}</p>
      </div>
      <div css={theme => ({ padding: theme.spacing(2) })}>
        <FilterDrawer
          title="Filter Options"
          filters={mockFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onClose={() => {}}
          footer={
            <Button
              css={{ width: '100%' }}
              onClick={() => setSelectedFilters({})}
              icon={<XIcon />}
              variant="plain"
              label={'Clear all'}
            />
          }
        />
      </div>
    </PatternCard>
  )
}
